const Main = () => import(/* webpackChunkName: "exoty" */ '@/modules/main/main.vue');
const EmptyRouterView = () => import(/* webpackChunkName: "exoty" */ '@/components/EmptyRouter.vue');
const PiggybankAdd = () => import(/* webpackChunkName: "piggy" */ '@/modules/piggybank/view/add.vue');
const PiggybankBoost = () => import(/* webpackChunkName: "piggy" */ '@/modules/piggybank/view/boost.vue');
const PiggybankEdit = () => import(/* webpackChunkName: "piggy" */ '@/modules/piggybank/view/edit.vue');
const PiggybankList = () => import(/* webpackChunkName: "piggy" */ '@/modules/piggybank/view/index.vue');
const PiggybankTranslate = () => import(/* webpackChunkName: "piggy" */ '@/modules/piggybank/view/translate.vue');

export const ROUTE_NAME_PIGGYBANK = {
    BOOST: 'PiggybankBoost',
    ITEM: {
        INDEX: 'PiggybankList',
        ADD: 'PiggybankAdd',
        EDIT: 'PiggybankEdit',
        CLONE: 'PiggybankClone',
        TRANSLATE: 'PiggybankTranslate'
    }
} as const;

export default [
    {
        path: '/app/:appId/piggybank',
        component: Main,
        meta: { requiresAuth: true },
        children: [
            {
                path: 'boost',
                name: ROUTE_NAME_PIGGYBANK.BOOST,
                component: PiggybankBoost,
                meta: { requiresAuth: true }
            },
            {
                path: 'item',
                component: EmptyRouterView,
                meta: { requiresAuth: true },
                children: [
                    {
                        path: '',
                        name: ROUTE_NAME_PIGGYBANK.ITEM.INDEX,
                        component: PiggybankList,
                        meta: { requiresAuth: true }
                    },
                    {
                        path: 'add',
                        name: ROUTE_NAME_PIGGYBANK.ITEM.ADD,
                        component: PiggybankAdd,
                        meta: { requiresAuth: true }
                    },
                    {
                        path: ':id/edit',
                        name: ROUTE_NAME_PIGGYBANK.ITEM.EDIT,
                        component: PiggybankEdit,
                        meta: { requiresAuth: true }
                    },
                    {
                        path: ':id/clone',
                        name: ROUTE_NAME_PIGGYBANK.ITEM.CLONE,
                        component: PiggybankAdd,
                        meta: { requiresAuth: true }
                    },
                    {
                        path: ':id/translate',
                        name: ROUTE_NAME_PIGGYBANK.ITEM.TRANSLATE,
                        component: PiggybankTranslate,
                        meta: { requiresAuth: true }
                    }
                ]
            }
        ]
    }
];
